import { LocalizedEnum } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { PaymentCardState, PaymentMethod, SepaDirectDebitProviderState } from '@mews-commander/data-access';
import {
    getTagVariantFromPaymentMethodState,
    isCardPaymentMethodState,
    isSepaPaymentMethodState,
} from '../tables/PaymentMethods/utils';

interface Props {
    paymentMethod: PaymentMethod;
    state: PaymentCardState | SepaDirectDebitProviderState;
    outline?: boolean;
}

export const PaymentMethodStateTag = ({ paymentMethod, state, outline = true }: Props) => {
    if (isSepaPaymentMethodState(paymentMethod, state)) {
        return (
            <Tag variant={getTagVariantFromPaymentMethodState(state)} outline={outline}>
                <LocalizedEnum prefix="SepaDirectDebitProviderState" value={state} />
            </Tag>
        );
    }

    if (isCardPaymentMethodState(paymentMethod, state)) {
        return (
            <Tag variant={getTagVariantFromPaymentMethodState(state)} outline={outline}>
                <LocalizedEnum prefix="PaymentCardState" value={state} />
            </Tag>
        );
    }

    return null;
};
